import React, { useEffect, useState } from 'react'
import '../../../styles/jobPostingsStyle.css'
import post1 from "../../../assets/post1.png"
import post2 from "../../../assets/post2.png"
import post3 from "../../../assets/post3.png"
import post4 from "../../../assets/post4.png"
import post5 from "../../../assets/post5.png"
import post6 from "../../../assets/post6.png"
import post7 from "../../../assets/post7.png"
import post8 from "../../../assets/post8.png"
import post9 from "../../../assets/post9.png"
import post10 from "../../../assets/post10.png"
import copyIcon from "../../../assets/content_copy.svg"
import cross from "../../../assets/closeembed.svg"
import { FiMoreVertical } from "react-icons/fi";
import arrowUp from '../../../assets/arrow_warm_up.png'
import PostNewJobPopup from './PostNewJobPopup'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../Loader/Loader'
import { closeJobPost, getCareerPageLink, getJobPost } from '../../services/operations/jobPostAPI'
import ConfirmationPopup from './ConfirmationPopup'
import { getUserDetails } from '../../services/operations/profileAPI'
import toast from 'react-hot-toast'
import { message } from '../../messages/Message'


const JobPosting = () => {

  const [showPopup, setShowPopup] = useState(false);
  const [jobId, setJobId] = useState('');
  const [jobs, setJobs] = useState([]);
  const [showEmbedBox, setShowEmbedBox] = useState(false);
  const [iframeText, setIframeText] = useState('');

  const [loadData, setLoadData] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [count, setCounts] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [timeFilter, setTimeFilter] = useState("year");

  const loading = useSelector((state) => state.auth.loading)
  const token = useSelector((state) => state.auth.token)
  const url = useSelector((state) => state.url.urlLink)
  const user = useSelector((state) => state.profile.user)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const urlFilter = queryParams.get("filter") || "active";

  const [filter, setFilter] = useState(urlFilter);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlFilter = searchParams.get("filter");

    if (urlFilter) {
      setFilter(urlFilter);
    }
  }, [location.search]);


  const fetchJobs = async (page = 1) => {
    const params = { page };
    if (filter === 'active') params.is_active = true;
    if (filter === 'closed') params.is_close = true;
    if (filter === 'draft') params.is_draft = true;

    if (timeFilter === "year") params.year = true;
    if (timeFilter === "month") params.month = true;
    if (timeFilter === "week") params.week = true;

    setLoadData(true);

    const result = await dispatch(getJobPost(token, params));
    if (result?.data) {
      const { data, current_page, last_page, next_page_url, prev_page_url, counts } = result.data.data;

      setJobs(data);

      setCurrentPage(current_page);
      setTotalPages(last_page);
      setHasNextPage(!!next_page_url);
      setHasPrevPage(!!prev_page_url);

    }
    if (result?.data?.counts) {
      setCounts(result.data.counts)

    }
    setLoadData(false);

  };

  useEffect(() => {
    fetchJobs(currentPage);
  }, [currentPage, filter, timeFilter]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleFilterClick = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(1);
  };

  const handleTimeFilterChange = (event) => {
    setTimeFilter(event.target.value);
    setCurrentPage(1);
  };

  const togglePopup = () => {
    if (!user?.is_premium) {
      toast.error(message.postMessgae)
      navigate("/business-dashboard/subscription")
    }
    setShowPopup(!showPopup);
  };

  const handleRowClick = (id) => {
    const url = `/business-dashboard/jobpost-detail?id=${id}&filter=${filter}`;
    window.open(url, "_blank")
    // navigate(`/business-dashboard/jobpost-detail?id=${id}&filter=${filter}`);
  };

  const handleCandidateClick = (job, type) => {
    const minimalData = {
      type: type,
      jobId: job.id,
      jobTitle: job.job_title,
      skills: job?.skills,
      niceToHaveSkills: job?.nice_to_have_skills,
      company: job?.company_name,
      industry: job?.industries,
      location: job.job_location,
      experience: job?.experience,
      type: type
    }

    if (type === "Applicants") {
      const encodedData = btoa(encodeURIComponent(JSON.stringify(minimalData)));
      const detailsURL = `/business-dashboard/applicants?data=${encodedData}`;
      window.open(detailsURL, '_blank');
    }
    if (type === "Passive") {
      const encodedData = btoa(encodeURIComponent(JSON.stringify(minimalData)));
      const detailsURL = `/business-dashboard/relevant-candidates?data=${encodedData}`;
      window.open(detailsURL, '_blank');
    }

  };
  const handleClosePost = async (id) => {
    setConfirmPopup(true);
    setJobId(id);
  }

  const handleGenerateLink = async () => {
    const response = await dispatch(getCareerPageLink(token))
    await dispatch(getUserDetails(token))

  }

  const handleOpenUrl = () => {
    const detailUrl = `${window.location.origin}${url}`;
    window.open(detailUrl, "_blank");
  };


  const handleShowEmbedBox = () => {
    const embedUrl = `${window.location.origin}${url}`;
    const defaultIframe = `<iframe src="${embedUrl}" height="1200px" width="1600px"></iframe>`;
    setIframeText(defaultIframe);
    setShowEmbedBox(true);
  };



  return (
    <div className='jobpost-dashboard'>
      {loading && <Loader />}
      <div className='jobpost-uppar'>
        <div className='jobpost-first'>
          <div className='jobpost-container' style={{ position: "relative" }}>
            <img src={post1} alt='post1' className='postone' />
            <img src={post3} alt='post3' className='posttwo' />
            <img src={post4} alt='post4' className='postthree' />
            <img src={post5} alt='post5' className='postfour' />
            <img src={post6} alt='post6' className='postfive' />
            <img src={post7} alt='post7' className='postsix' />
            <img src={post8} alt='post8' className='postseven' />
            <img src={post9} alt='post9' className='posteigth' />
            <img src={post10} alt='post10' className='postnine' />
          </div>
          <p className='jobpost-first-heading'>
            Post and generate career page to Hire your Ideal candidate!
          </p>
          <p className='jobpost-first-subheading'>Explore more than 80M+ profiles</p>
          <div className='jobpost-create-generate-button'>
            {user?.roles?.some(role => role.name !== "team-member") && (
              <button className='jobpost-button' onClick={togglePopup}>
                Post New Job
              </button>
            )}
            {
              url ? (
                <button
                  className='jobpost-button2'
                  onClick={handleShowEmbedBox}
                  style={{ cursor: "pointer", fontSize: "18px" }}>
                  Embed career page Link
                </button>
              ) : (
                (
                  user?.roles?.some(role => role.name !== "team-member") && (
                    <button className='jobpost-button2' onClick={handleGenerateLink}>Generate career page</button>
                  )
                )
              )
            }

          </div>
          <div style={{ height: "51px", width: "100%" }}>
            {showEmbedBox && (
              <div className="embed-container">
                <input
                  type="text"
                  value={iframeText}
                  onChange={(e) => setIframeText(e.target.value)}
                  className="embed-text-bar"
                />

                <img
                  src={copyIcon}
                  alt="Copy"
                  className="copy-icon-search-bar"
                  onClick={() => {
                    navigator.clipboard.writeText(iframeText);
                    toast.success(message.careerPageCopyMessage);
                  }}
                />

                <img
                  src={cross}
                  alt="Close"
                  className="cross-icon-embed-bar"
                  onClick={() => {
                    setIframeText('');
                    setShowEmbedBox(false);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className='jobpost-second'>
          <p className='jobpost-second-heading'>Status</p>
          <div className='jobpost-controls'>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
              <button
                className={`jobpost-btn-active-btn ${filter === 'active' ? 'active' : ''}`}
                onClick={() => handleFilterClick('active')}
              >Active</button>
              <button
                className={`jobpot-btn-close-btn ${filter === 'closed' ? 'active' : ''}`}
                onClick={() => handleFilterClick('closed')}
              >Closed</button>
              <button
                className={`jobpot-btn-close-btn ${filter === 'draft' ? 'active' : ''}`}
                onClick={() => handleFilterClick('draft')}
              >Draft</button>
            </div>
            <select
              value={timeFilter}
              className='dropdown-filter-month'
              onChange={handleTimeFilterChange}
            >
              <option value="year">Year</option>
              <option value="month">Month</option>
              <option value="week">Week</option>
            </select>
          </div>

          <div className='jobpost-stats'>
            <div className='jobpost-box'>
              <div className='jobpost-content'>
                <h3 className="jobpost-name">{count?.total}</h3>
                <p className="jobpost-count">Job Posts</p>
              </div>
              <span className="navigate-icon" style={{ width: "40.92px", height: "40.92px" }}>{">"}</span>
            </div>
            <div className='jobpost-box'

            >
              <div className='jobpost-content'>
                <h3 className="jobpost-name">{count?.applicants}</h3>
                <p className="jobpost-count">Applicants</p>
              </div>
              <span className="navigate-icon" style={{ width: "40.92px", height: "40.92px" }}>{">"}</span>
            </div>
            <div className='jobpost-box'
            >
              <div className='jobpost-content'>
                <h3 className="jobpost-name">{count?.shortlisted}</h3>
                <p className="jobpost-count">Shortlisted</p>
              </div>
              <span className="navigate-icon" style={{ width: "40.92px", height: "40.92px" }}>{">"}</span>
            </div>
            <div className='jobpost-box'
            >
              <div className='jobpost-content'>
                <h3 className="jobpost-name">{count?.hired}</h3>
                <p className="jobpost-count">Hired</p>
              </div>
              <span className="navigate-icon" style={{ width: "40.92px", height: "40.92px" }}>{">"}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='jobpost-lower'>
        <div className='jobpost-table-header'>
          <h3>
            {filter === "closed"
              ? "Previously Posted Jobs"
              : filter === "draft"
                ? "Saved Draft"
                : "Posted Jobs"}
          </h3>
        </div>

        <table className='jobpost-table'>

          <tbody>
            {loadData ?
              [...Array(5)].map((_, index) => (
                <tr key={index}>
                  <td colSpan={"8"} style={{ padding: '20px' }}>
                    <div className="skeleton-row"></div>
                  </td>
                </tr>
              )) :
              jobs.length > 0 ? (
                jobs.map((job, index) => (
                  <tr
                    key={index}
                  >
                    <td className='jobpost-table-name'>
                      <img
                        src={job.profile_image ? job.profile_image : `https://api.dicebear.com/5.x/initials/svg?seed=${job.name}`}
                        alt='profile' style={{ width: "27px", height: "27px", borderRadius: "50%" }} />
                    </td>
                    <td className='jobpost-table-name' style={{ cursor: 'pointer' }} onClick={() => handleRowClick(job.id)}>{job.job_title}</td>
                    <td style={{ fontWeight: "400" }}>{job.job_location}</td>
                    <td>
                      <button
                        className={`employment-type-btn ${job.workplace_type === "Remote"
                          ? "remote"
                          : job.workplace_type === "Onsite"
                            ? "onsite"
                            : "hybrid"
                          }`}
                      >
                        {job.workplace_type}
                      </button>
                    </td>
                    <td>{job.employment_type}</td>
                    <td>
                      {job?.experience && job.experience !== "N/A" ? (
                        (() => {
                          let parsed;

                          try {
                            if (typeof job.experience === "string") {
                              parsed = JSON.parse(job.experience);
                              parsed = Array.isArray(parsed) ? parsed : [parsed];
                            } else if (Array.isArray(job.experience)) {
                              parsed = job.experience;
                            } else {
                              parsed = [job.experience];
                            }
                          } catch (e) {
                            parsed = [job.experience];
                          }

                          return `${parsed.join(", ")} years`;
                        })()
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td style={{ fontWeight: "700" }}>
                      {job?.contract_price_per_hrs && job.contract_price_per_hrs !== "N/A"
                        ? `$${job.contract_price_per_hrs}/hr`
                        : job?.salary_range && job.salary_range !== "N/A"
                          ? job.salary_range
                          : "N/A"}
                    </td>
                    {/* <td
                      onClick={job?.applicant_count > 0 ? () => handleCandidateClick(job, "Applicants") : undefined}
                      style={{ cursor: job?.applicant_count > 0 ? 'pointer' : 'default' }}
                    >
                      <button className='applicant-btn'>
                        <img src={arrowUp} alt="up" />
                        &nbsp;&nbsp;{job?.applicant_count} {job?.applicant_count <= 1 ? 'Applicant' : 'Applicants'}
                      </button>
                    </td> */}
                    {/* <td
                      onClick={job?.passivecandidate > 0 ? () => handleCandidateClick(job, "Passive") : undefined}
                      style={{ cursor: job?.passivecandidate > 0 ? 'pointer' : 'default' }}
                    >
                      <button className='applicant-btn'>
                        {job?.passivecandidate} Passive {job?.passivecandidate <= 1 ? "candidate" : "candidates"}
                      </button>
                    </td> */}
                    <td>
                      {job.job_status === "CLOSED" ? (
                        <button className='jobpost-close-btn' disabled>Closed</button>
                      ) : (
                        user?.roles?.some(role => role.name !== "team-member") && (
                          <button
                            className='jobpost-close-btn'
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClosePost(job.id);
                            }}
                          >
                            Close Post
                          </button>
                        )
                      )}
                    </td>

                  </tr>
                ))
              ) :
                (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center' }}>No jobs found</td>
                  </tr>)
            }
          </tbody>
        </table>
        <div className='jobpost-pagination'>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={!hasPrevPage}
            className='jobpost-page-btn'
          >
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              className={`jobpost-page-btn-count ${currentPage === index + 1 ? 'active' : ''}`}
              style={{
                margin: '0 5px',
                color: currentPage === index + 1 ? 'white' : 'rgba(122, 122, 122, 1)',
                background: currentPage === index + 1 ? 'rgba(45, 118, 253, 1)' : 'transparent',
                cursor: 'pointer'
              }}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={!hasNextPage}
            className='jobpost-page-btn'
          >
            Next
          </button>
        </div>
      </div>
      {showPopup && <PostNewJobPopup onClose={togglePopup} fetchJobs={fetchJobs} />}
      {confirmPopup && <ConfirmationPopup onClose={() => setConfirmPopup(false)} id={jobId} fetchJobs={fetchJobs} filter={filter} setFilter={setFilter} />}
    </div>
  )
}

export default JobPosting